import LeadForm from "../components/LeadForm";
import { Phone, MessageCircle, MapPin, Clock, Mail } from "lucide-react";
import { Button } from "../components/ui/button";

export default function ContactPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20 grid lg:grid-cols-5 gap-10">
      <div className="lg:col-span-2 space-y-5">
        <div className="text-xs uppercase tracking-[0.24em] text-secondary font-bold">Contact</div>
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter">Let’s power your ride, home or business.</h1>
        <p className="text-muted-foreground">Reach us any time during business hours. We usually respond within a few minutes on WhatsApp.</p>

        <div className="space-y-3 pt-2">
          <Row icon={MapPin} label="Address" value={<>Near HP Petrol Pump,<br />Bajaj Road, Sikar (Raj.) 332001</>} />
          <Row icon={Phone} label="Phone" value={<><a className="hover:text-secondary" href="tel:+919829219117">+91 98292 19117</a><br /><a className="hover:text-secondary" href="tel:+919549390000">+91 95493 90000</a><br /><a className="hover:text-secondary" href="tel:+919530498888">+91 95304 98888</a></>} />
          <Row icon={Mail} label="Email" value={<a className="hover:text-secondary" href="mailto:amaronstoresikar@gmail.com">amaronstoresikar@gmail.com</a>} />
          <Row icon={Clock} label="Hours" value="Mon–Sat 10:00 am – 8:00 pm · Sunday Closed" />
        </div>

        <div className="flex flex-wrap gap-3 pt-2">
          <a href="tel:+919549390000"><Button className="rounded-full bg-primary text-black hover:bg-secondary hover:text-white"><Phone className="h-4 w-4 mr-1.5" /> Call Now</Button></a>
          <a href="https://wa.me/919530498888" target="_blank" rel="noreferrer"><Button variant="outline" className="rounded-full border-black/15"><MessageCircle className="h-4 w-4 mr-1.5" /> WhatsApp</Button></a>
          <a href="https://www.google.com/maps?gs_lcrp=EgZjaHJvbWUqCAgCEEUYJxg7MgYIABBFGDwyBggBEEUYPDIICAIQRRgnGDsyBggDEEUYOTIICAQQRRgnGDsyBggFEEUYPDIGCAYQRRhBMgYIBxBFGEHSAQg0NzcxajBqN6gCCLACAfEFoNjPM30danU&um=1&ie=UTF-8&fb=1&gl=in&sa=X&geocode=KXcLJzbJpGw5MVvH0kg0rsGJ&daddr=Bajaj+Rd,+near+Sundaram+Petrol+Pump,+Subhash+Chowk,+Sikar,+Rajasthan+332001" target="_blank" rel="noreferrer"><Button variant="outline" className="rounded-full border-black/15"><MapPin className="h-4 w-4 mr-1.5" /> Directions</Button></a>
        </div>
      </div>

      <div className="lg:col-span-3">
        <LeadForm />
      </div>
    </div>
  );
}

function Row({ icon: Icon, label, value }) {
  return (
    <div className="flex items-start gap-3">
      <div className="h-9 w-9 rounded-lg bg-primary/10 border border-primary/30 flex items-center justify-center flex-shrink-0">
        <Icon className="h-4 w-4 text-secondary" />
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-[0.24em] font-bold text-muted-foreground">{label}</div>
        <div className="mt-0.5 text-sm">{value}</div>
      </div>
    </div>
  );
}
